import LabelData from './LabelData';

export default LabelData;
